import { Link } from "react-router-dom";

import "../../styles/DevelopmentAdmin.css";

function DevelopmentComingSoon({
  title,
  description,
}) {
  return (
    <div className="development-admin-placeholder">
      <p className="development-admin-eyebrow">
        Avwakin Development
      </p>

      <h2>{title}</h2>

      <p>
        {description ||
          "This administration page is ready for its data-management interface."}
      </p>

      <Link
        to="/avwakindevelopment/admin"
        className="development-admin-button secondary"
      >
        Return to dashboard
      </Link>
    </div>
  );
}

export default DevelopmentComingSoon;